export const SortOrder = {
	Descending: "desc",
	Ascending: "asc",
};
